var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/social/facebook-share.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg viewBox=\"0 0 95 95\" class=\"c-social__facebook\" aria-labelledby=\"facebook-share-svg-title\" xmlns=\"http://www.w3.org/2000/svg\">\n    <title id=\"facebook-share-svg-title\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["social-facebook"])), env.opts.autoescape);
output += "\n    </title>\n    <path d=\"M47.5 0C21.3 0 0 21.3 0 47.5S21.3 95 47.5 95 95 73.7 95 47.5 73.7 0 47.5 0zM62.3 31.2h-9c0 0-2.1-0.1-2.1 3 0 3 0 4.4 0 4.4h11.1v11.1H51.2V75l-10.4-0.1v-0.4V49.6h-8.2V38.5h8.2v-4.3c0 0 0.1-13.5 12.5-14.2h9L62.3 31.2z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/social/facebook-share.j2"] , dependencies)